/* eslint-disable max-len */
/* eslint-disable no-console */
import {Carousel, Col, Flex} from 'antd';
import React, {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';

import EFDatabasesLogo from '../../../assets/addEmissionFactorDB.png';
import AddEmployeesLogo from '../../../assets/addEmployees.png';
import AddFacilityLogo from '../../../assets/addFacility.png';
import AddHoldingsLogo from '../../../assets/addHoldings.png';
import AddSuppliersLogo from '../../../assets/addSuppliers.png';
import AddUsersLogo from '../../../assets/addUsers.png';
import BusinessDetailsLogo from '../../../assets/businessDetails.png';
import close_SM from '../../../assets/Close_SM.svg';
import selectedCheckMark from '../../../assets/selectedCheckmark.svg';
import UpgradeButton from '../../../components/UpgradeButton/UpgradeButton';
import {allRoutes, Routes} from '../../../constants/Routes';
import {
  accessModule,
  countModule
} from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {removeSlash} from '../../../utils/removeSlash';
import {
  hasMaxLimitReached,
  shouldBlockModuleAccess,
  isOnboardingDone,
  shouldBlockFree
} from '../../../utils/SubscriptionHelper';

import AddBtn from './AddBtn';
import HeaderTitle from './HeaderTitle';

// interface BusinessItem {
//   title: string;
//   logo: string;
//   details: string;
//   actionType: any;
//   selected: boolean;
//   route: string;
// }

const GetStarted: React.FC<{
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
}> = ({setOpenKeys}) => {
  const {setCtaHome, ctaHome} = useUserStore.getState();

  const navigate = useNavigate();

  useEffect(() => {
    if (ctaHome.length === 0) {
      setCtaHome([
        {
          title: 'Add Business Details',
          logo: BusinessDetailsLogo,
          details:
            'Business details are significant to derive your intensity metrics.',
          route: `${allRoutes.Configurator.org_facility}?tab=businessDetails`,
          actionType: 'Add Business Details',
          selected: false,
          isBlock: () => {
            return shouldBlockFree();
          }
        },
        {
          title: 'Add Holdings',
          logo: AddHoldingsLogo,
          details:
            'Holding details are essential for BRSR compliance and Scope 3 emissions accounting.',
          route: `${allRoutes.Configurator.org_facility}?tab=holding`,
          actionType: 'Add Holdings',
          selected: false,
          isBlock: () => {
            return (
              shouldBlockModuleAccess(accessModule.externalStakeholders) ||
              hasMaxLimitReached(countModule.externalStakeholders) ||
              shouldBlockFree()
            );
          }
        },
        {
          title: 'Add Facilities',
          logo: AddFacilityLogo,
          details:
            'Comprehensive emission data can be achieved by providing detailed facility information.',
          route: `${allRoutes.Configurator.org_facility}?tab=FacilityInformation`,
          actionType: 'Add Facilities',
          selected: false,
          isBlock: () => {
            return (
              shouldBlockModuleAccess(accessModule.facility) ||
              hasMaxLimitReached(countModule.facility) ||
              shouldBlockFree()
            );
          }
        },
        {
          title: 'Add Employees',
          logo: AddEmployeesLogo,
          details:
            'An integral part of your company that significantly contributes to Scope 3 emissions accounting.',
          route: `${allRoutes.Configurator.org_facility}?tab=empData`,
          actionType: 'Add Employees',
          selected: false,
          isBlock: () => {
            return (
              shouldBlockModuleAccess(accessModule.employees) ||
              shouldBlockFree()
            );
          }
        },
        {
          title: 'Emission Factor Databases',
          logo: EFDatabasesLogo,
          details:
            'Define your emission calculation pathway by selecting the appropriate databases.',
          route: `${allRoutes.Configurator.data_management}?.tab=EFDatabase`,
          actionType: 'Emission Factor Databases',
          selected: false,
          isBlock: () => {
            return shouldBlockFree();
          }
        },
        {
          title: 'Add Suppliers',
          logo: AddSuppliersLogo,
          details:
            'Suppliers are a crucial part of your value chain, offering significant opportunities for decarbonization.',
          route: `${allRoutes.Configurator.valueChainMng}?tab=supplier_Info`,
          actionType: 'Add Suppliers',
          selected: false,
          isBlock: () => {
            return (
              shouldBlockModuleAccess(accessModule.externalStakeholders) ||
              hasMaxLimitReached(countModule.externalStakeholders) ||
              shouldBlockFree()
            );
          }
        },
        {
          title: 'Add Users',
          logo: AddUsersLogo,
          details:
            'Accelerate data collection by enabling users to fill in data for their respective departments and facilities.',
          route: `${allRoutes.Configurator.user_management}`,
          actionType: 'Add Users',
          selected: false,
          isBlock: () => {
            return (
              ((hasMaxLimitReached(countModule.externalStakeholders) ||
                shouldBlockModuleAccess(accessModule.externalStakeholders)) &&
                hasMaxLimitReached(countModule.internalUsers)) ||
              shouldBlockFree()
            );
          }
        }
      ]);
    }
  }, []);

  const handleClick = (route: string) => {
    const updatedData = ctaHome.map((item) => {
      return item.route === route ? {...item, selected: true} : item;
    });
    setCtaHome(updatedData);
    navigate(route);
  };

  const handleRemoveItem = (index: number) => {
    const updatedData = ctaHome.filter((_, i) => i !== index);
    setCtaHome(updatedData);
  };

  const configuratorRoute = removeSlash(Routes.CONFIGURATOR);
  const splitArray = (arr: any[], size: number) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }

    return result;
  };
  const splittedItems = splitArray(ctaHome, 4);
  const carouselRef = useRef<any>(null);
  const scrollNext = () => {
    carouselRef.current?.next();
  };

  const scrollPrev = () => {
    carouselRef.current?.prev();
  };

  return (
    <div className="getStartedContainer">
      <HeaderTitle
        headText={'Get Started'}
        subText={''}
        hasOption={true}
        scrollPrev={scrollPrev}
        scrollNext={scrollNext}
      />
      <Carousel dots={true} arrows={false} ref={carouselRef}>
        {splittedItems.map((group, groupIndex) => (
          <div key={groupIndex}>
            <div
              style={{
                display: 'flex',
                justifyContent: group.length < 4 ? 'flex-start' : 'center',
                gap: '24px',
                padding: groupIndex === 0 ? '20px 40px' : '20px 0'
              }}
            >
              {group.map((item, itemIndex) => {
                const realIndex = groupIndex * 3 + itemIndex;

                return (
                  <Col
                    key={realIndex}
                    className="cardComponent"
                    span={6}
                    style={{
                      padding: '0px 18px',
                      flex: '0 0 auto',
                      position: 'relative'
                    }}
                  >
                    <div className="titleRow">
                      <h3 className="cardTitle">{item.title}</h3>
                      <img
                        src={item.selected ? selectedCheckMark : close_SM}
                        style={{
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer'
                        }}
                        alt="check"
                        onClick={() => {
                          !item.selected && handleRemoveItem(realIndex);
                        }}
                      />
                    </div>
                    <Flex gap={10} vertical align="center">
                      <img className="logoStyle" src={item.logo} />
                      <p
                        style={{
                          margin: 0,
                          color: '#555',
                          textAlign: 'center'
                        }}
                        className="cardDetails"
                      >
                        {item.details}
                      </p>
                      <div style={{position: 'absolute', bottom: '24px'}}>
                        {item.isBlock() ? (
                          <UpgradeButton title={item.actionType} />
                        ) : (
                          <AddBtn
                            isSelected={item.selected}
                            actionProp={item.actionType}
                            btnPress={() => {
                              if (isOnboardingDone()) {
                                handleClick(item.route);
                                setOpenKeys(
                                  configuratorRoute
                                    ? Array.isArray(configuratorRoute)
                                      ? configuratorRoute
                                      : [configuratorRoute]
                                    : []
                                );
                              }
                            }}
                          />
                        )}
                      </div>
                    </Flex>
                  </Col>
                );
              })}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default GetStarted;
